import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider } from "./contexts/AuthContext";

// Chrome can surface benign ResizeObserver warnings as runtime errors in dev
// (notably with charting libraries). This prevents the red error overlay from
// blocking the UI for this known noise.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      const msg = String((event as ErrorEvent)?.message || "");
      if (
        msg.includes("ResizeObserver loop limit exceeded") ||
        msg.includes("ResizeObserver loop completed with undelivered notifications")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const authMode =
  localStorage.getItem("auth_mode") === "individual" ? "individual" : "org";
const domain =
  process.env.REACT_APP_AUTH0_DOMAIN || "dev-ociu84lf8keizm5i.us.auth0.com";
const orgClientId =
  process.env.REACT_APP_AUTH0_ORG_CLIENT_ID ||
  "s9ZUbsCK8M5gUlbuwW8kscKcLiS48ccb";
const individualClientId =
  process.env.REACT_APP_AUTH0_INDIVIDUAL_CLIENT_ID ||
  "TUitNXrMgzgIbBXeWe5eVCaQYSURXogh";
const clientId = authMode === "individual" ? individualClientId : orgClientId;

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${domain}/api/v2/`,
        scope: "openid profile email read:current_user",
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage">
      <AuthProvider>
        <App />
      </AuthProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
